import React, { Component } from "react"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import axios from "axios"
import { Auth } from 'aws-amplify'
import { motivosdes, motivoshab } from "../motivos";

class Deshabilitar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            skus_procesar: [{
                Sku: '',
                Solicitado_por: '',
                Motivo: this.props.accion === 'DES'? "Descuadre de inventario":"Se corrigió inventario",
                Comentario: '',
                Accion: props.accion,
                Obteniendo: false,
                Obtuvo: false,
                sku_info: {},
                modificado: false,
                error: false,
                error_text: '',
                error_type: 200
            }],
            notification: (<div></div>),
            sendingRequest: false,
            loggedUser: "",
            verificoUsuario: false
        }
        this.renderSkuFields = this.renderSkuFields.bind(this)
        this.procesarSkus = this.procesarSkus.bind(this)
        this.getSkuInfo = this.getSkuInfo.bind(this)
    }

    /**
     * Verifica la sesion al cargar la vista y obtiene el usuario que inicio sesion.
     */
    componentDidMount() {
        Auth.currentAuthenticatedUser()
        .then(user => {
            this.setState({
                loggedUser: user.username,
                verificoUsuario: true
            })
        })
        .catch(error => {
            let mensaje = 'Hubo un error inesperado'
            if (error.message) mensaje = error.message
            this.setState({
                notification: (
                    <div className='alert alert-danger'>
                        {mensaje}
                    </div>
                )
            })
        })
    }

    /**
     * Envia una peticion a la API con los SKUs que se desean procesar
     * @param {*} e Evento del boton.
     */
    procesarSkus(e) {
        e.preventDefault()
        if (this.state.skus_procesar.length > 0 && this.state.verificoUsuario) {
            this.setState({
                sendingRequest: true
            })
            let skus_procesar = this.state.skus_procesar
            for (let i = 0; i < skus_procesar.length; i++)
                skus_procesar[i]['Usuario'] = this.state.loggedUser
            axios({
                url: process.env.REACT_APP_API_URL + '/api/v1/registrar_skus',
                method: 'POST',
                data: {
                    Skus: this.state.skus_procesar.map(x=>{return {...x, sku_info:{}}})
                }
            }).then(data => {
                this.setState({
                    notification: (
                        <div className='alert alert-success'>
                            {data.data.message}
                        </div>
                    ),
                    skus_procesar: [{
                        Sku: '',
                        Comentario: '',
                        Motivo: '',
                        Accion: this.props.accion,
                        Obteniendo: false,
                        Obtuvo: false,
                        sku_info: {},
                        modificado: false,
                        error: false,
                        error_text: '',
                        error_type: 200
                    }],
                })
            }).catch(error => {
                let mensaje = 'Hubo un error inesperado'
                if (error.response) 
                    if (error.response.data.message) mensaje = error.response.data.message
                this.setState({
                    notification: (
                        <div className='alert alert-danger'>
                            {mensaje}
                        </div>
                    )
                })
            }).finally(() => {
                this.setState({
                    sendingRequest: false
                })
            })
        } else {
            this.setState({
                notification: (
                    <div className='alert alert-danger'>
                        Ingrese SKUs para procesar
                    </div>
                )
            })
        }
    }

    /**
     * Realiza una peticion a la API para obtener la informacion del SKU ingresado
     * @param {*} sku_pos Posicion en la que se encuentra el SKU en el array de skus a procesar
     */
    getSkuInfo(sku_pos) {
        if (this.state.skus_procesar[sku_pos].Sku.length > 0 && this.state.skus_procesar[sku_pos].modificado) {
            let skus_procesar_array = this.state.skus_procesar
            skus_procesar_array[sku_pos].Obteniendo = true
            skus_procesar_array[sku_pos].modificado = false
            skus_procesar_array[sku_pos].Obtuvo = false
            skus_procesar_array[sku_pos].error = false
            this.setState({
                skus_procesar: skus_procesar_array,
                sendingRequest: true
            })
            let sku = this.state.skus_procesar[sku_pos].Sku
            axios({
                url: process.env.REACT_APP_API_URL + '/api/v1/sku_info?Sku=' + sku,
                method: 'GET'
            }).then(data => {
                skus_procesar_array[sku_pos].Obtuvo = true
                skus_procesar_array[sku_pos].Obteniendo = false
                skus_procesar_array[sku_pos].sku_info = data.data
                this.setState({
                    skus_procesar: skus_procesar_array
                })
            }).catch(error => {
                skus_procesar_array[sku_pos].Obtuvo = false
                skus_procesar_array[sku_pos].Obteniendo = false
                skus_procesar_array[sku_pos].error = true
                skus_procesar_array = this.state.skus_procesar
                if (error.response) {
                    skus_procesar_array[sku_pos].error_type = error.response.status
                    if (error.response.data.message) skus_procesar_array[sku_pos].error_text = error.response.data.message
                    else skus_procesar_array[sku_pos].error_text = 'Hubo un error inesperado'
                } else {
                    skus_procesar_array[sku_pos].error_type = 500
                    skus_procesar_array[sku_pos].error_text = 'Hubo un error inesperado'
                }
                this.setState({
                    skus_procesar: skus_procesar_array
                })
            }).finally(() => {
                this.setState({
                    sendingRequest: false
                })
            })
        }
    }

    /**
     * Recorre el listado de SKUs que se ingresan para enviar a la API para mostrarlos en una tabla.
     * @returns Retorna el contenido de la tabla HTML con los SKUs que se deben procesar
     */
    renderSkuFields() {

        const Motivos = () =>{
            if (this.props.accion === 'DES') {
                return<>
                    {
                        motivosdes.map((v, i) =>{
                            return <option>{motivosdes[i]}</option>
                        })
                    }
                </>
            }else{
                return<>
                    {
                        motivoshab.map((v, i) =>{
                            return <option>{motivoshab[i]}</option>
                        })
                    }
                </>
            }
        }

        return this.state.skus_procesar.map((item, index) => {
            return (
                <div className='row mt-5' key={index}>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-md-1 d-flex justify-content-center'>
                                <table style={{
                                    height: '100%'
                                }}>
                                    <tbody>
                                        <tr>
                                            <td className='align-middle'>
                                                <FontAwesomeIcon role='button' icon={faTrash} onClick={() => {
                                                    let skus_array = this.state.skus_procesar
                                                    skus_array.splice(index, 1)
                                                    this.setState({
                                                        skus_procesar: skus_array
                                                    })
                                                }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='col-md-2'>
                                <div className='form-group'>
                                    <label>SKU</label>
                                    <input type='text' className='form-control' readOnly={this.state.skus_procesar[index].Obteniendo} onBlur={() => {
                                        this.getSkuInfo(index)
                                    }} id='sku' required aria-describedby='skuHelp' autoFocus onChange={(e) => {
                                        let skus_array = this.state.skus_procesar
                                        skus_array[index].Sku = e.target.value
                                        skus_array[index].modificado = true
                                        this.setState({
                                            skus_procesar: skus_array
                                        })
                                    }} value={this.state.skus_procesar[index].Sku} />
                                    <small id='skuHelp' className='form-text text-muted'></small>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='form-group'>
                                    <label>Solicitado por</label>
                                    <input type='text' className='form-control' id='solicitadopor' required aria-describedby='' onChange={(e) => {
                                        let skus_array = this.state.skus_procesar
                                        skus_array[index].Solicitado_por = e.target.value
                                        this.setState({
                                            skus_procesar: skus_array
                                        })
                                    }} defaultValue={this.state.skus_procesar[index].Solicitado_por}/>
                                    
                                    <small id='comentarioHelp' className='form-text text-muted'></small>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <label>Motivo</label>
                                    <select className='form-control' id='motivo' required aria-describedby='motivoHelp' onChange={(e) => {
                                        console.log(e.target.value);
                                        let skus_array = this.state.skus_procesar
                                        skus_array[index].Motivo = e.target.value
                                        this.setState({
                                            skus_procesar: skus_array
                                        })
                                    }} defaultValue={this.state.skus_procesar[index].Motivo}>
                                    {Motivos()}
                                    </select>
                                    <small id='motivoHelp' className='form-text text-muted'></small>
                                </div>
                            </div> 
                            <div className='col-md-12'>
                                <div className='form-group'>
                                    <label>Comentario</label>
                                    <textarea className='form-control' id='comentario' required aria-describedby='comentarioHelp' onChange={(e) => {
                                        let skus_array = this.state.skus_procesar
                                        skus_array[index].Comentario = e.target.value
                                        this.setState({
                                            skus_procesar: skus_array
                                        })
                                    }} defaultValue={this.state.skus_procesar[index].Comentario}></textarea>
                                    <small id='comentarioHelp' className='form-text text-muted'></small>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.skus_procesar[index].Obtuvo ? 
                            (
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <small>
                                                    <strong>Nombre de producto: </strong>
                                                    {this.state.skus_procesar[index].sku_info.ProductName}
                                                </small>
                                            </div>
                                            <div className='col-md-3'>
                                                <small>
                                                    <strong>¿El producto esta activo? </strong>
                                                    {this.state.skus_procesar[index].sku_info.IsProductActive ? 'Si' : 'No'}
                                                </small>
                                            </div>
                                            <div className='col-md-3'>
                                                <small>
                                                    <strong>Id de producto: </strong>
                                                    {this.state.skus_procesar[index].sku_info.ProductId}
                                                </small>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <small>
                                                    <strong>Nombre del SKU: </strong>
                                                    {this.state.skus_procesar[index].sku_info.SkuName}
                                                </small>
                                            </div>
                                            <div className='col-md-3'>
                                                <small>
                                                    <strong>¿SKU Activo? </strong>
                                                    {this.state.skus_procesar[index].sku_info.IsActive ? 'Si' : 'No'}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : this.state.skus_procesar[index].error ? (
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='alert alert-danger' role='alert'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    {this.state.skus_procesar[index].error_text}
                                                </div>
                                            </div>
                                            {
                                                (this.state.skus_procesar[index].error_type !== 404) ? (
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <button type="button" className="btn btn-link">Reintentar obtener informacion</button>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
            )
        })
    }

    /**
     * Renderiza la pagina
     * @returns Vista de la pagina
     */
    render() {
        return (
            <div>
                <div className='row mt-5'>
                    <div className='col-md-12 text-center'>
                        <h2>{this.props.accion === 'DES' ? 'Deshabilitar' : 'Habilitar'} SKU</h2>
                        <small>
                            {this.props.accion === 'DES' ? 'Deshabilitar' : 'Habilitar'} SKUs en VTEX
                        </small>
                        <hr className='mt-5' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {this.state.notification}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <form onSubmit={this.procesarSkus} >
                            {this.renderSkuFields()}
                            <div className='row mt-5'>
                                <div className='col-6'>
                                    <button className='btn btn-outline-secondary' onClick={() => {
                                        let new_array = this.state.skus_procesar;
                                        new_array.push({
                                            Sku: '',
                                            Usuario: '',
                                            Comentario: '',
                                            Motivo: '',
                                            Accion: this.props.accion,
                                            Obteniendo: false,
                                            Obtuvo: false,
                                            sku_info: {},
                                            modificado: false,
                                            error: false
                                        })
                                        this.setState({
                                            skus_procesar: new_array
                                        })
                                    }}>
                                        Agregar otro SKU
                                    </button>
                                </div>
                                <div className='col-md-6'>
                                    <div className='d-flex justify-content-end'>
                                        {
                                            !this.state.sendingRequest ? 
                                                (<button className='btn btn-primary'>
                                                    {this.props.accion === 'DES' ? 'Desactivar' : 'Activar'} {this.state.skus_procesar.length} SKU{this.state.skus_procesar.length > 1 ? 's' : ''}
                                                </button>) : 
                                                (<button className='btn btn-primary' disabled>
                                                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                    <span className="sr-only">Procesando...</span>
                                                </button>)
                                        }
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default Deshabilitar